module.exports = __webpack_public_path__ + "static/img/erweima.fecc9ee7.png";